'use client';

import { ReactNode } from 'react';

export default function RootTemplate({ children }: { children: ReactNode }) {
  return children;
}
